import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import AnnouncementModel from './announcement';
import FundSettingModel from './fund-setting';
import OrgSettingModel from './org-setting';
import UserSettingModel from './user-setting';
import GoalModel from './goal';
import ContactCustomPropertyUserSettingModel from './contact-custom-property-user-setting';
import UserFundSettingModel from './user-fund-setting';
import MailchimpFundSyncSlimModel from './mailchimp-fund-sync-slim';

export default class AllSettingModel extends Model {
  @attr('boolean') fundIsSyncedWithUserNewsletterAccount!: boolean;
  @belongsTo('user-setting', { async: false, inverse: null })
  userSettings!: UserSettingModel;
  @belongsTo('fund-setting', { async: false, inverse: null })
  fundSettings!: FundSettingModel;
  @belongsTo('org-setting', { async: false, inverse: null })
  orgSettings!: OrgSettingModel;
  @belongsTo('mailchimp-fund-sync-slim', { async: false, inverse: null })
  mailchimpFundSyncSlim?: MailchimpFundSyncSlimModel;
  @belongsTo('announcement', { async: false, inverse: null })
  announcement?: AnnouncementModel;
  @belongsTo('goal', { async: false, inverse: null }) goal?: GoalModel;
  @belongsTo('contact-custom-property-user-setting', {
    async: false,
    inverse: null,
  })
  contactCustomPropertyUserSetting?: ContactCustomPropertyUserSettingModel;
  @hasMany('user-fund-setting', { async: false, inverse: null })
  userFundSettings?: UserFundSettingModel[];
}
